import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getWorkTimeTypes } from "../services/workTimeBetaService";
import { WorkTimeType } from "../models/workShitTimeSlot/workTimeType";

interface MonitorViewFiltersState {
    workTimeTypeIds: (string | null)[];
    working: boolean;
    noWork: boolean;
    noWorkTime: boolean;
    workTimeTypes: WorkTimeType[] | null;
    workTimeTypesLoading: boolean;
    workTimeTypesError: string | null;
}

const initialState: MonitorViewFiltersState = {
    workTimeTypeIds: [],
    working: true,
    noWork: true,
    noWorkTime: true,
    workTimeTypes: null,
    workTimeTypesLoading: false,
    workTimeTypesError: null,
};

export const fetchWorkTimeTypes = createAsyncThunk(
    "monitorViewFilters/fetchWorkTimeTypes",
    async(_, { rejectWithValue }) => {
        try {
            const response = await getWorkTimeTypes();
            return response;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const monitorViewFiltersSlice = createSlice({
    name: "monitorViewFilters",
    initialState,
    reducers: {
        setWorkTimeTypeIds(state, action) {
            state.workTimeTypeIds = action.payload;
        },
        toggleWorkTimeTypeId(state, action) {
            const { id, checked } = action.payload;
            if (checked) {
                state.workTimeTypeIds.push(id);
            } else {
                state.workTimeTypeIds = state.workTimeTypeIds.filter(
                    (workTimeTypeId) => workTimeTypeId !== id
                );
            }
        },
        setWorking(state, action) {
            state.working = action.payload;
        },
        setNoWork(state, action) {
            state.noWork = action.payload;
        },
        setNoWorkTime(state, action) {
            state.noWorkTime = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkTimeTypes.pending, (state) => {
                state.workTimeTypesLoading = true;
                state.workTimeTypesError = null;
            })
            .addCase(fetchWorkTimeTypes.fulfilled, (state, action) => {
                state.workTimeTypes = action.payload;
                state.workTimeTypesLoading = false;
            })
            .addCase(fetchWorkTimeTypes.rejected, (state, action) => {
                state.workTimeTypesError = action.payload as string;
                state.workTimeTypesLoading = false;
            });
    },
});

export const {
    setWorkTimeTypeIds,
    toggleWorkTimeTypeId,
    setWorking,
    setNoWork,
    setNoWorkTime,
} = monitorViewFiltersSlice.actions;

export const monitorViewFiltersReducer = monitorViewFiltersSlice.reducer;